import { rtkApi } from './api';
import { TAGS } from './tags';

const enhancedNewsCountApi = rtkApi.enhanceEndpoints({
    addTagTypes: [
        TAGS.NEWS_COUNT
    ],
    endpoints: {
        getApiV1NewsCount: {
            providesTags: [TAGS.NEWS_COUNT]
        }
    }
});

export const {
    useGetApiV1NewsCountQuery
} = enhancedNewsCountApi;

export { enhancedNewsCountApi };
